module.exports = __webpack_public_path__ + "static/media/animated_ashutosh2.760ef48c.png";